define('client',[
    'jquery',
    'underscore',
    'backbone',
    'marionette',
    'bootstrap',
    'modules/auth/models/session.model',
    'modules/base/models/client.token.model',
    'modules/base/models/token.model',
    'modules/base/models/user.model',
    'modules/base/models/utils.model',
], function($, _, Backbone,Marionette,Bootstrap,
            SessionModel,
            ClientTokenModel,
            TokenModel,
            UserModel,
            UtilsModel
){
    var Prospector = new Marionette.Application();

    Prospector.navigate = function(route,  options){
        options || (options = {});
        Backbone.history.navigate(route, options);
    };

    Prospector.getCurrentRoute = function(){
        return Backbone.history.fragment
    };

    Prospector.getBrowserInfo = function(){
        var ua=navigator.userAgent,tem,M=ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        if(/trident/i.test(M[1])){
            tem=/\brv[ :]+(\d+)/g.exec(ua) || [];
            return 'IE '+(tem[1]||'');
        }
        if(M[1]==='Chrome'){
            tem=ua.match(/\bOPR\/(\d+)/)
            if(tem!=null)   {return 'Opera '+tem[1];}
        }
        M=M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
        if((tem=ua.match(/version\/(\d+)/i))!=null) {M.splice(1,1,tem[1]);}
        return {
            name: M[0],
            version: M[1]
        };
    };
    Prospector.compatibility = function(){
        var browser = Prospector.getBrowserInfo();
        var triggerAlert = true;
        switch(window.utils.browserName){
            case "Chrome":{
                if(browser.version > 30){
                    triggerAlert = false;
                }
                break;
            }
            case "Firefox":{
                if(browser.version > 33){
                    triggerAlert = false;
                }
                break;
            }
            case "Safari":{
                if(browser.version > 6){
                    triggerAlert = false;
                }
                break;
            }
            case "Explorer":{
                if(browser.version == undefined){
                    var split  = browser.split(" ");
                    if(split.length > 1 &&  split[1] > 9) {
                        triggerAlert = false;
                    }
                } else if( window.utils.browserVersion > 9){
                    triggerAlert = false;
                }
                break;
            }
        }
        if(triggerAlert){
            /*require(["modules/home/modal/views/not.supported.view"], function(NotSupportedView){
                var nsv = new NotSupportedView();
                Prospector.trigger('showModal', {view: nsv, title: 'Browser Not Supported',height:320,width:500});
            });*/
        }
    };

    Prospector.startSubApp = function(appName, args){
        var currentApp = appName ? Prospector.module(appName) : null;
        if (Prospector.currentApp === currentApp){ return; }

        if (Prospector.currentApp){
            Prospector.currentApp.stop();
        }

        Prospector.currentApp = currentApp;
        if(currentApp){
            currentApp.start(args);
        }
    };
    Prospector.on( "loadCss", function(url) {
        var link = document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        var a = Math.floor((Math.random() * 100000) + 1);
        link.href = url + "?version=" + a;
        document.getElementsByTagName("head")[0].appendChild(link);
    });

    Prospector.on("init", function(){
        Prospector.isFirstLoad = true;
        window.typeAheadWait = 850;
        window.utils = new UtilsModel();
        window.session = new SessionModel();
        window.clientToken = new ClientTokenModel();
        window.token = new TokenModel();
        window.user = new UserModel();
    });

    Prospector.on("before:start", function(){
        Prospector.trigger("init");
    });

    Prospector.on("start", function(){

        var sayswho= function(){

            var navigator = window.navigator;

            var returnObj = {
                browser: "IE",
                version: "11"
            };

            try{
                var ua= navigator.userAgent, tem,
                    M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
                if(/trident/i.test(M[1])){
                    tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
                    returnObj.browser = 'IE';
                    returnObj.version = tem[1];
                    return returnObj;
                }
                if(M[1]=== 'Chrome'){
                    tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
                    returnObj.browser = 'Chrome';
                    returnObj.version =  M[1];
                }
                M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
                if((tem= ua.match(/version\/(\d+)/i))!= null){
                    M.splice(1, 1, tem[1]);
                }
                returnObj.browser =  M[0];
                returnObj.version =  M[1];
                return returnObj;
            }

            catch (error){
                if(console != undefined){
                    console.error(error);
                }
            }
            return returnObj;

        };

        var browser = sayswho();
        if(browser.browser == "IE"){
            document.getElementsByTagName('body')[0].className += "ieFix";
        }
        Prospector.addRegions({
            mainRegion: $("body"),
            modalRegion: '.modal-dialog'
        });
        if(Backbone.history) {
            $.ajaxSetup({
                cache: false,
                beforeSend: function (xhr)
                {
                    var userToken = window.utils.readCookie('userToken');
                    var unaToken = window.utils.readCookie('unaToken');

                    if(userToken){
                        xhr.setRequestHeader("userToken", userToken);
                    }

                    if(unaToken){
                        xhr.setRequestHeader("unaToken", unaToken);
                    }

                },
                complete: function (xhr)
                {
                    var userToken = xhr.getResponseHeader('userToken');
                    var unaToken = xhr.getResponseHeader('unaToken');
                    if(userToken){
                        window.utils.createCookie('userToken', userToken,0.01);
                    }
                    if(unaToken){
                        window.utils.createCookie('unaToken', unaToken,0.01);
                    }
                }
            });

            require([
                     "modules/auth/auth.module",
                     "modules/base/base.module",

            ], function (
                AuthAppRouter,
                BaseModule
            ) {
                Backbone.history.start();
                window.redirectUrl = Prospector.getCurrentRoute();
                if( Prospector.getCurrentRoute() === ""){
                    Prospector.compatibility();
                    Prospector.navigate('login', {trigger: true});
                }
            });
        }
    });
    window.app = Prospector;
    return Prospector;
});


